/**
 * useEmbed Hook
 *
 * Erkennt den Embed-Mode (iFrame im HeyKiki-Portal oder Cockpit-Preview-Overlay)
 * anhand des URL-Parameters ?embed=1 ODER der Tatsache, dass die App in einem
 * iframe läuft. Wird von Layout.jsx verwendet um Navigation/Header/Footer
 * auszublenden.
 *
 * Warum zusätzlich iframe-Detection: In KiZentrale.jsx überschreibt
 * handleTabChange die Search-Params komplett (`setSearchParams({ tab })`),
 * wodurch `embed=1` beim Tab-Wechsel verloren geht. Der iframe-Check sorgt
 * dafür, dass das Embed-Layout auch dann stabil bleibt.
 */

import { useSearchParams } from 'react-router-dom';

export function useEmbed() {
  const [searchParams] = useSearchParams();
  const isEmbedParam = searchParams.get('embed') === '1';
  const isInIframe = typeof window !== 'undefined' && window.self !== window.top;
  const isEmbed = isEmbedParam || isInIframe;
  return { isEmbed };
}
